const criteria = [
  { icon: 'ri-bank-card-2-line', text: '신용카드 소지자 (국내 카드사 기준)' },
  { icon: 'ri-user-line', text: '만 19세 이상 성인이라면 누구나' },
  { icon: 'ri-shield-star-line', text: '현재연체중만아니라면' },
  { icon: 'ri-home-office-line', text: '재직자 / 사업자 / 주부 / 프리랜서 모두 가능' },
  { icon: 'ri-percent-line', text: '본인카드 한도 보유자' },
  { icon: 'ri-building-4-line', text: '법인카드(대표 및 임원)' },
];

const conditions = [
  { label: '대출 한도', value: '신용카드 한도내', color: 'text-[#03C75A]' },
  { label: '처리 시간', value: '신속 5분입금처리가능', color: 'text-[#03C75A]' },
  { label: '신청 방법', value: '전화 / 비대면', color: 'text-[#03C75A]' },
  { label: '서비스', value: '24시간 365일', color: 'text-[#03C75A]' },
];

export default function EligibilitySection() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="eligibility" className="py-12 md:py-24 bg-[#f7f9fa]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-8 md:mb-16">
          <span className="inline-block bg-[#03C75A]/10 text-[#03C75A] text-xs sm:text-sm font-bold px-3 sm:px-4 py-1.5 rounded-full mb-3 sm:mb-4">
            자격기준
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-gray-900 mb-3">이런 분들께 적합합니다</h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-10 items-start">
          {/* Left: Criteria List */}
          <div>
            <div className="bg-white rounded-2xl p-5 sm:p-8 border border-gray-100">
              <h3 className="text-base sm:text-xl font-bold text-gray-900 mb-4 sm:mb-6 flex items-center gap-2">
                <i className="ri-checkbox-circle-line text-[#03C75A] text-xl sm:text-2xl"></i>
                대출 자격기준
              </h3>
              <ul className="space-y-3 sm:space-y-4">
                {criteria.map((item) => (
                  <li key={item.text} className="flex items-center gap-3 sm:gap-4">
                    <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-[#03C75A]/10 rounded-xl shrink-0">
                      <i className={`${item.icon} text-lg sm:text-xl text-[#03C75A]`}></i>
                    </div>
                    <span className="text-sm sm:text-base text-gray-700 font-medium leading-snug">{item.text}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Conditions */}
            <div className="grid grid-cols-2 gap-3 sm:gap-4 mt-3 sm:mt-4">
              {conditions.map((c) => (
                <div key={c.label} className="bg-white rounded-xl p-3 sm:p-4 border border-gray-100 text-center">
                  <div className={`text-sm sm:text-xl font-black ${c.color} mb-1 leading-tight`}>{c.value}</div>
                  <div className="text-xs text-gray-500 mt-1">{c.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: CTA Card */}
          <div className="flex flex-col gap-4 sm:gap-6">
            <div className="bg-gradient-to-br from-[#03C75A] to-[#00A843] rounded-2xl p-5 sm:p-8 text-white">
              <div className="inline-block bg-white/20 text-white text-xs font-bold px-3 py-1 rounded-full mb-3 sm:mb-4">
                24시간 상담 가능
              </div>
              <h3 className="text-2xl sm:text-3xl font-black mb-2">지금 바로<br />자격 확인하기</h3>
              <p className="text-white/80 text-sm mb-4 sm:mb-6">
                대출한도등 적합 여부를 신속하게 확인해드립니다.
              </p>
              <div className="flex flex-col gap-2 sm:gap-3">
                <a
                  href="tel:01066065909"
                  className="flex items-center justify-center gap-2 bg-white text-[#03C75A] font-bold py-3 sm:py-4 rounded-xl text-base sm:text-lg hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-phone-fill"></i>
                  010-6606-5909
                </a>
                <a
                  href="tel:027045909"
                  className="flex items-center justify-center gap-2 bg-white/20 text-white font-semibold py-2.5 sm:py-3 rounded-xl text-sm hover:bg-white/30 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-phone-line"></i>
                  02-704-5909
                </a>
              </div>
            </div>

            {/* Image */}
            <div className="relative rounded-2xl overflow-hidden h-44 sm:h-56">
              <img
                src="https://public.readdy.ai/ai/img_res/bb02dcc68fca071977e519d45993b5bf.jpg"
                alt="대출 상담"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent flex items-end p-4 sm:p-5">
                <p className="text-white font-bold text-sm sm:text-lg">전문 상담사가 직접 안내해드립니다</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
